import { useEffect, useState } from "react";
import { useFormik } from "formik";
import { object, string } from "yup";
import { isTemplateExisits } from "../../../../utils/commonFunctions";
import Config from "../../../../config/app.config.json";
import EnvConfig from "../../../../config/env.config.json";
import { getCC } from "../../../../features/account/accountSlice";
import firebase from "../../../../adapters/firebase";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { getImeiCheck } from "../../../../features/activation/activationSlice";
import { countryList } from "../../../../config/USAStateList";
import { NotificationCust } from "../../../widgets";
import FirebaseDBURLs from "../../../../config/FirebaseDBURLs";
import {
  checkCompatibility,
  getInTouchApi,
} from "../../../../features/homepage/homepageSlice";
import { BrandNameUpdate } from "../../../../utils/commonFunctions/BrandNameUpdate";
import { getAppDataFetch } from "../../../../features/checkout/checkoutSlice";

interface formikintitaltypes {
  imei: string;
}
const ActivationStep1Comp = isTemplateExisits(Config.Activation.ActivationStep1)
  ? require(`./${Config.Activation.ActivationStep1.template}_ActivationStep1`)
      .default
  : null;
export const ActivationStep1 = (props: any) => {
  const { currentLine, content, gaHandler, handleStep, updatingCustomer } =
    props;
  const dispatch = useAppDispatch();
  const { subDomainData } = useAppSelector((state: any) => state.homepage);
  const onTimeActivation = localStorage.getItem("oneTimeactivation");

  const [kitBasePrice, setKitBasePrice] = useState<any>(null);
  const [sendSimOption, setSimOption] = useState([]);
  const [btnLoader, setBtnLoader] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [deviceComp, setDeviceComp] = useState(
    currentLine?.imei ? true : false
  );
  const [currentModal, setCurrentModal] = useState(
    onTimeActivation ? "oneTimeChrg" : ""
  );

  const [isEsimAvailable, setIsEsimAvailable] = useState(false);
  const [isPsimAvailable, setIsPsimAvailable] = useState(false);
  const [imeiModel, setImeiModel] = useState("");
  const [errModalMsg, setErrModalMsg] = useState("");
  const [imeiErrorModal, setImeiErrorModal] = useState(false);

  const { imeiData, imeiNumber } = useAppSelector(
    (state: any) => state?.activation || {}
  );

  const { msgs, imei_error_modal } = content || {};
  const { isValid, model, make } = imeiData || {};

  const customerDetails: any = JSON.parse(
    localStorage?.getItem("customerDetail") || "null"
  );
  useEffect(() => {
    const customerStoreData: any = JSON.parse(
      localStorage?.getItem("customerDetail") || "null"
    );
    if (customerStoreData)
      dispatch(getCC({ customerId: customerStoreData?.id }));
    fetchData();
  }, []);

  useEffect(() => {
    if (isValid && make && model && currentLine.esim !== true) {
      setDeviceComp(true);
    }
  }, [imeiData, isValid]);

  const fetchData = async () => {
    let firstObj: any;
    let sendSimOptions: any = [];
    dispatch(getAppDataFetch()).then((res: any) => {
      if (res?.payload?.status === 200) {
        res?.payload?.data?.data?.shippingRates?.map((el: any) => {
          return sendSimOptions.push({
            label: `${el?.name} - $${el?.shippingAmount?.toFixed(2)}`,
            value: el?.serviceType,
            cost: el?.shippingAmount,
            ...el,
          });
        });
        firstObj = sendSimOptions?.[0];
        setSimOption(sendSimOptions);
      }
    });

    const perCost: any = await firebase.database().ref(FirebaseDBURLs.simCost);
    let kitBasePrice = 0;

    perCost.on("value", (snapshot: any) => {
      const data = snapshot.val();
      kitBasePrice =
        data?.USA && ((100 - data.USA.discountPctg) * data.USA.cost) / 100;
      setKitBasePrice(kitBasePrice);
    });
  };

  const hubspotPy = {
    emailId: currentLine?.emailId,
    hubspotMap: {
      device_imei: imeiNumber,
      device_make: make,
      device_model: model,
      website_imei_incompatibility_reason: "",
      is_test: EnvConfig?.IS_HUBSPOT_TEST_ENV,
      is_qa: EnvConfig?.IS_HUBSPOT_QA_ENV,
      brand_name: subDomainData?.data?.brandName || EnvConfig.BRAND_NAME,
    },
  };

  const activationStep1Schema = object({
    imei: string().min(15, msgs?.valid_msg),
  });
  const initialformstep1data: formikintitaltypes = {
    imei: currentLine?.imei || "",
  };

  const formik = useFormik({
    initialValues: initialformstep1data,
    validationSchema: activationStep1Schema,
    onSubmit: (values: any) => {
      setBtnLoader(true);
      // commented to use new api
      // const py: any = {
      //   countryCode: countryList?.[0]?.value?.toLowerCase(),
      //   imei: values?.imei,
      // };

      const secondaryUser: any = JSON.parse(
        localStorage?.getItem("secondaryCustomerDetail") || "null"
      );
      let imeiSuccessMsg = content?.step_txt_next
        ? secondaryUser
          ? msgs.imei_noti_sec
          : msgs.imei_noti
        : msgs.imei_noti;
      gaHandler("check");
      ImeiCheckHandler(values?.imei, imeiSuccessMsg);
    },
    enableReinitialize: true,
  });

  const ImeiCheckHandler = async (imeiNumber: any, imeiSuccessMsg: any) => {
    if (imeiNumber.length < 14) {
      return;
    }
    if (imeiNumber && imeiNumber.length === 15 && /^\d+$/.test(imeiNumber)) {
      dispatch(checkCompatibility({ imeiNumber: imeiNumber })).then(
        (response: any) => {
          let compatibilityData = response?.payload?.data?.data;
          const { isValid, make, model } = compatibilityData || {};
          if (response?.payload?.status === 200 && compatibilityData) {
            if (compatibilityData?.inProgress) {
              setTimeout(() => {
                // call api
                ImeiCheckHandler(imeiNumber, imeiSuccessMsg);
              }, 10000);
            } else if (
              response?.payload?.status === 200 &&
              response?.payload?.data?.data?.isValid &&
              make &&
              model
            ) {
              setIsEsimAvailable(response?.payload?.data?.data?.esimAvailable);
              setIsPsimAvailable(response?.payload?.data?.data?.psimAvailable);
              NotificationCust({
                message: BrandNameUpdate(imeiSuccessMsg),
                duration: 10000,
                id: "activationIMEISuccess",
                showIcon: true,
              });

              !EnvConfig.IS_PSIM_TO_ESIM_SWAP_ALLOWED && handleStep(true);
              dispatch(
                getInTouchApi({
                  data: hubspotPy,
                })
              );
              updatingCustomer({
                imei: response?.meta?.arg?.imeiNumber.toString(),
                make: compatibilityData?.make,
                model: compatibilityData?.model,
                os: compatibilityData?.os,
                osVer: compatibilityData?.osVer,
              });
              setCurrentModal("chooseType");
            } else if (
              (response?.payload?.status === 200 &&
                !response?.payload?.data?.data?.isValid) ||
              response?.error?.code
            ) {
              setImeiModel(response?.payload?.data?.data?.model);
              if (
                response?.payload?.data?.data?.isLostOrStolen?.toLowerCase() ===
                "yes"
              ) {
                setErrModalMsg(imei_error_modal?.lostImei);
                setImeiErrorModal(true);
              } else if (
                response?.payload?.data?.data?.isLocked?.toLowerCase() === "yes"
              ) {
                setErrModalMsg(imei_error_modal?.lockedImei);
                setImeiErrorModal(true);
              } else if (
                response?.payload?.data?.data?.filteredDevice?.toLowerCase() ===
                "yes"
              ) {
                setErrModalMsg(imei_error_modal?.filteredImei);
                setImeiErrorModal(true);
              } else {
                setModalStatus(true);
              }
            } else {
              dispatch(
                getInTouchApi({
                  data: {
                    ...hubspotPy,
                    hubspotMap: {
                      ...hubspotPy.hubspotMap,
                      website_imei_incompatibility_reason: "IMEI Invalid",
                    },
                  },
                })
              );
              setModalStatus(true);
            }
          }
          setBtnLoader(false);
        }
      );
    } else {
      setModalStatus(true);
    }
  };

  return (
    <ActivationStep1Comp
      sendSimOption={sendSimOption}
      kitBasePrice={kitBasePrice}
      deviceComp={deviceComp}
      setDeviceComp={setDeviceComp}
      currentModal={currentModal}
      setCurrentModal={setCurrentModal}
      formik={formik}
      btnLoader={btnLoader}
      setBtnLoader={setBtnLoader}
      modalStatus={modalStatus}
      setModalStatus={setModalStatus}
      imeiModel={imeiModel}
      setImeiModel={setImeiModel}
      errModalMsg={errModalMsg}
      setErrModalMsg={setErrModalMsg}
      imeiErrorModal={imeiErrorModal}
      setImeiErrorModal={setImeiErrorModal}
      isEsimAvailable={isEsimAvailable}
      setIsEsimAvailable={setIsEsimAvailable}
      isPsimAvailable={isPsimAvailable}
      setIsPsimAvailable={setIsPsimAvailable}
      {...props}
    />
  );
};
